import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { CardType } from './card-type';
import { PaymentAccountStatus } from './payment-account-status';
import { PaymentMethod } from './payment-method';
import { PaymentProcessor } from './payment-processor';

// TODO: This is a mix of the backend PaymentAccountRO and PaymentAccountDetailRO.
// We should reconcile this at some point and replace crm usages with the PaymentAccountDetail where relevant.

@inheritSerialization(AbstractModel)
export class PaymentAccount extends AbstractModel {
  @autoserializeAs(PaymentMethod)
  paymentMethod: PaymentMethod;

  @autoserializeAs(PaymentAccountStatus)
  paymentAccountStatus: PaymentAccountStatus;

  @autoserialize
  personId: number;

  @autoserialize
  userDescription: string;

  @autoserialize
  chargeOrder: number;

  @autoserialize
  processorAccountId: number;

  @autoserialize
  active: boolean;

  @autoserialize
  billingFirstName: string;

  @autoserialize
  billingLastName: string;

  @autoserialize
  billingStreetAddress1: string;

  @autoserialize
  billingStreetAddress2: string;

  @autoserialize
  billingCity: string;

  @autoserialize
  billingState: string;

  @autoserialize
  billingCountry: string;

  @autoserialize
  billingZipCode: string;

  @autoserializeAs(Date)
  billingDateOfBirth: Date;

  @autoserialize
  billingSsnLastFour: number;

  @autoserializeAs(CardType)
  cardType: CardType;

  @autoserialize
  cardNumber: string;

  @autoserialize
  cardExpiration: string;

  @autoserialize
  cardVerificationValue: string;

  @autoserialize
  bankRoutingNumber: string;

  @autoserialize
  bankAccountNumber: string;

  @autoserialize
  bankAccountType: string;

  @autoserialize
  payPalAccountName: string;

  @autoserializeAs(PaymentProcessor)
  paymentProcessor: PaymentProcessor;

  @autoserialize
  processorCustomerId: string;

  @autoserializeAs(Date)
  tosAcceptanceDate: Date;

  @autoserialize
  tosAcceptanceIpAddress: string;

  @autoserialize
  createdByUserId: number;

  @autoserialize
  createdBy: string;

  @autoserialize
  verified: boolean;

  @autoserialize
  userVerified: boolean;

  static OnSerialized(instance: PaymentAccount, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.cardNumber)) {
      json['cardNumber'] = instance.cardNumber.replace(/\D/g, '');
    }

    if (!isNullOrUndefined(instance.tosAcceptanceDate)) {
      json.tosAcceptanceDate = DateUtil.serializeDate(instance.tosAcceptanceDate);
    }

    if (!isNullOrUndefined(instance.billingDateOfBirth)) {
      json.billingDateOfBirth = DateUtil.serializeDate(instance.billingDateOfBirth);
    }
  }

  static OnDeserialized(instance: PaymentAccount, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['tosAcceptanceDate'])) {
      instance.tosAcceptanceDate = DateUtil.deserializeDate(json['tosAcceptanceDate']);
    }

    if (!isNullOrUndefined(json['billingDateOfBirth'])) {
      instance.billingDateOfBirth = DateUtil.deserializeDate(json['billingDateOfBirth']);
    }
  }
}
